import { render, staticRenderFns } from "./SingleSport.vue?vue&type=template&id=d8fa5638&"
import script from "./SingleSport.vue?vue&type=script&lang=js&"
export * from "./SingleSport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports